module.exports = __webpack_public_path__ + "media/video.90b0e7d0.mp4";